import api from './api';
import type { DashboardStats, MonthlyExpenses, Transaction } from '../types';

class DashboardService {
  /**
   * Get dashboard data including stats and recent transactions
   */
  async getDashboard(): Promise<DashboardStats> {
    const response = await api.get<{
      success: boolean;
      data?: DashboardStats;
      error?: string;
    }>('/client/dashboard');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar dashboard');
  }

  /**
   * Get monthly expenses breakdown
   */
  async getMonthlyExpenses(mes: number, ano: number): Promise<MonthlyExpenses> {
    const response = await api.get<{
      success: boolean;
      data?: any;
      error?: string;
    }>(`/client/dashboard/expenses/monthly?month=${mes}&year=${ano}`);

    if (response.data.success && response.data.data) {
      const d = response.data.data;
      return {
        mes,
        ano,
        total: d.total || 0,
        totalTransacoes: d.total_transacoes || 0,
        categorias: (d.categorias || []).map((c: any) => ({
          categoria: c.categoria || 'Outros',
          valor: c.valor || 0,
          percentagem: c.percentagem || 0,
        })),
      };
    }

    throw new Error(response.data.error || 'Falha ao carregar despesas');
  }

  /**
   * Get recent transactions for dashboard
   */
  async getRecentTransactions(limit: number = 5): Promise<Transaction[]> {
    const response = await api.get<{
      success: boolean;
      data?: Transaction[];
      error?: string;
    }>(`/client/transactions?limit=${limit}`);

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar transações recentes');
  }
}

export default new DashboardService();
